/** Figma `1:605` — Sensemaker List page layout tokens. */
export { APP_SHELL_PAGE_PADDING_PX as SENSEMAKER_LIST_PAGE_PADDING_PX } from '@/shared/layout/appShellPageLayout'
export {
  APP_SHELL_PAGE_TITLE_SUBTITLE_GAP_PX as SENSEMAKER_LIST_TITLE_SUBTITLE_GAP_PX,
  APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX as SENSEMAKER_LIST_TITLE_ROW_TO_PILLS_GAP_PX,
} from '@/shared/layout/appShellPageLayout'
export const SENSEMAKER_LIST_PILLS_TO_GRID_GAP_PX = 32
export const SENSEMAKER_LIST_FILTER_WIDTH_PX = 225
export const SENSEMAKER_LIST_FILTER_GAP_PX = 20
export const SENSEMAKER_LIST_FILTER_LABEL_VALUE_GAP_PX = 10
export const SENSEMAKER_LIST_PILL_GAP_PX = 8
export const SENSEMAKER_LIST_CARD_GRID_GAP_PX = 20
export const SENSEMAKER_LIST_CARD_MIN_HEIGHT_PX = 342
export const SENSEMAKER_LIST_CARD_HORIZONTAL_PADDING_PX = 15
export const SENSEMAKER_LIST_CARD_TOP_PADDING_PX = 13
export const SENSEMAKER_LIST_CARD_BOTTOM_PADDING_PX = 15
export const SENSEMAKER_LIST_CARD_HEADER_HEIGHT_PX = 54
export const SENSEMAKER_LIST_CARD_HEADER_AVATAR_SIZE_PX = 32
export const SENSEMAKER_LIST_CARD_HEADER_AVATAR_GAP_PX = 8
export const SENSEMAKER_LIST_CARD_HEADER_NAME_PACKAGE_GAP_PX = 2
export const SENSEMAKER_LIST_CARD_HEADER_BOTTOM_PADDING_PX = 10
export const SENSEMAKER_LIST_CARD_HEADER_TO_STATS_GAP_PX = 13
export const SENSEMAKER_LIST_CARD_HEADER_STATUS_RESERVE_PX = 88
export const SENSEMAKER_LIST_CARD_INFO_HEIGHT_PX = 58
export const SENSEMAKER_LIST_CARD_INFO_VALUE_LABEL_GAP_PX = 1
export const SENSEMAKER_LIST_CARD_INFO_METRIC_GAP_PX = 102
export const SENSEMAKER_LIST_CARD_INFO_TO_TOKEN_GAP_PX = 20
export const SENSEMAKER_LIST_CARD_TOKEN_LABEL_TO_PROGRESS_GAP_PX = 8
export const SENSEMAKER_LIST_CARD_PROGRESS_TO_BUTTON_GAP_PX = 36
export const SENSEMAKER_LIST_CARD_BUTTON_HEIGHT_PX = 40
